import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { NEWS_API_PATH } from "@/modules/News/constants";

class newsService {
  private restClient: RestClientService;
  constructor() {
    this.restClient = new RestClientService();
  }
  public getAllNews(): Promise<ICoreResponse> {
    return this.restClient.get(NEWS_API_PATH.GET_NEWS, "");
  }
  public getFeaturedNews(): Promise<ICoreResponse> {
    return this.restClient.get(NEWS_API_PATH.GET_FEATURED_NEWS, "");
  }
}
export default newsService;
